exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".dsh-realname>section {\n  padding: 20px 18px 20px 18px;\n  display: flex;\n  flex-direction: row;\n}\n", ""]);
